import { makeStyles } from '@material-ui/core'
import React, { ReactElement } from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    padding: (p: Props) =>
      p.padded === false ? theme.spacing(0) : theme.spacing(3),
    margin: (p: Props) =>
      p.margin ? theme.spacing(p.margin) : theme.spacing(2),
    background: theme.palette.background.paper,
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 20
  }
}))
interface Props {
  children?: string | React.ReactNode
  onClick?: any
  item?: any
  margin?: number
  padded?: boolean
}

export default function SimpleCard({
  children,
  onClick,
  item,
  margin,
  padded
}: Props): ReactElement {
  const classes = useStyles({ margin, padded } as Props)

  const handleClick = () => {
    onClick && onClick(item)
  }
  return (
    <div className={classes.root} onClick={handleClick}>
      {children}
    </div>
  )
}
